export default __webpack_public_path__ + "static/media/4.06cb6df0.jpg";